(()=>{
  if(window.__purePindCroV17)return;
  window.__purePindCroV17=true;

  const COMBOS={
    'everyday-protein-trio':{components:['progain-protein-atta','pea-protein-isolate','soya-flour'],kicker:'Protein pantry trio',headline:'Three products. One protein-forward pantry move.',copy:'Protein across roti, shake and mix-in time.'},
    'sugar-smart-kitchen-kit':{components:['sugarsteady-atta','methi-powder','oats-flour'],kicker:'Thoughtful pantry kit',headline:'Three staples for a more considered everyday pantry.',copy:'A fibre-rich atta plus two familiar pantry ingredients for everyday routines.'},
    'lighter-everyday-bundle':{components:['litelift-atta','jowar-flour','chana-dal-flour'],kicker:'Fibre-forward bundle',headline:'More grain variety without making meals complicated.',copy:'LiteLift, jowar and chana bring variety across roti, bhakri and everyday cooking.'},
    'daily-flour-starter-box':{components:['whole-wheat-flour','jowar-flour','sprouted-ragi-flour','chana-dal-flour'],kicker:'Everyday flour starter',headline:'Four familiar flours. One easier first PurePind pantry.',copy:'A practical mix of wheat, jowar, sprouted ragi and chana dal flour for everyday Indian cooking.'}
  };

  const productCache=new Map();
  const money=(cents)=>{
    const value=(Number(cents)||0)/100;
    const decimals=Math.round(value)!==value?2:0;
    return '₹'+new Intl.NumberFormat('en-IN',{minimumFractionDigits:decimals,maximumFractionDigits:2}).format(value);
  };
  const percentOff=(anchor,price)=>anchor>price&&anchor>0?Math.max(1,Math.round(((anchor-price)/anchor)*100)):0;
  const handleFromPath=()=>{
    const match=location.pathname.match(/\/products\/([^/?#]+)/);
    return match?decodeURIComponent(match[1]):'';
  };
  const handleFromItem=(item)=>{
    if(item.handle)return item.handle;
    const url=String(item.url||'');
    const match=url.match(/\/products\/([^/?#]+)/);
    return match?decodeURIComponent(match[1]):'';
  };
  const fetchProduct=async(handle)=>{
    if(!handle)return null;
    if(productCache.has(handle))return productCache.get(handle);
    const promise=fetch('/products/'+encodeURIComponent(handle)+'.js',{headers:{Accept:'application/json'}}).then(r=>r.ok?r.json():null).catch(()=>null);
    productCache.set(handle,promise);
    return promise;
  };
  const imageUrl=(source)=>{
    if(!source)return '';
    if(typeof source==='string')return source;
    return source.src||source.url||source.preview_image?.src||'';
  };
  const variantForItem=(product,item)=>product?.variants?.find(v=>String(v.id)===String(item.variant_id))||null;
  const includedVariant=(product)=>product?.variants?.find(v=>/\b900\s*g?\b/i.test(String(v.title||'')))||product?.variants?.[0]||null;
  const isComboProduct=(product,handle)=>product?.type==='PurePind Combo'||Boolean(COMBOS[handle]);

  async function getCartContext(){
    const response=await fetch('/cart.js',{headers:{Accept:'application/json'},cache:'no-store'});
    if(!response.ok)throw new Error('Cart unavailable');
    const cart=await response.json();
    const handles=[...new Set(cart.items.map(handleFromItem).filter(Boolean))];
    const products=await Promise.all(handles.map(fetchProduct));
    const byHandle=new Map(handles.map((handle,index)=>[handle,products[index]]));
    return {cart,byHandle};
  }

  function linePricing(item,product,handle){
    const variant=variantForItem(product,item);
    const currentLine=Number(item.final_line_price)||0;
    const compareUnit=Number(variant?.compare_at_price)||0;
    const compareLine=compareUnit>0?compareUnit*(Number(item.quantity)||1):0;
    const validAnchor=compareLine>currentLine;
    const combo=isComboProduct(product,handle);
    return {
      combo,
      currentLine,
      anchorLine:validAnchor?compareLine:currentLine,
      discount:validAnchor?percentOff(compareLine,currentLine):0,
      anchorLabel:combo?'Buy separately':'MRP',
      priceLabel:combo?'Bundle price':'Our price'
    };
  }

  function priceStackHTML(pricing){
    const anchor=pricing.discount?`<span class="pp-v17-anchor"><small>${pricing.anchorLabel}</small><s>${money(pricing.anchorLine)}</s></span>`:'';
    const off=pricing.discount?`<em>${pricing.discount}% OFF</em>`:'';
    return `<div class="pp-v17-line-price">${anchor}<span class="pp-v17-live"><small>${pricing.priceLabel}</small><strong>${money(pricing.currentLine)}</strong></span>${off}</div>`;
  }

  function summaryHTML(context){
    const {cart,byHandle}=context;
    let anchorTotal=0;
    let hasCombo=false;
    let hasRegular=false;
    cart.items.forEach(item=>{
      const handle=handleFromItem(item);
      const pricing=linePricing(item,byHandle.get(handle),handle);
      anchorTotal+=pricing.anchorLine;
      if(pricing.combo)hasCombo=true;else hasRegular=true;
    });
    const current=Number(cart.total_price)||0;
    const saving=Math.max(0,anchorTotal-current);
    const pct=percentOff(anchorTotal,current);
    const label=hasCombo&&hasRegular?'MRP / separate value':hasCombo?'Buy separately':'Total MRP';
    return `<div class="pp-v17-cart-summary">
      <div><span>${label}</span><s>${money(anchorTotal)}</s></div>
      <div class="is-live"><span>Our price</span><strong>${money(current)}</strong></div>
      ${saving>0?`<div class="is-saving"><span>You save</span><strong>${money(saving)}${pct?` · ${pct}%` :''}</strong></div>`:''}
    </div>`;
  }

  let drawerBusy=false;
  async function enhanceDrawer(){
    const drawer=document.querySelector('[data-pp-cart-drawer]');
    const lines=drawer?.querySelector('[data-pp-cart-lines]');
    if(!drawer||!lines||drawerBusy)return;
    const rows=[...lines.querySelectorAll('.pp-cart-drawer-line')];
    if(!rows.length||rows.every(row=>row.dataset.ppV17Priced==='true'))return;
    drawerBusy=true;
    try{
      const context=await getCartContext();
      rows.forEach((row,index)=>{
        const item=context.cart.items[index];
        if(!item)return;
        const handle=handleFromItem(item);
        const pricing=linePricing(item,context.byHandle.get(handle),handle);
        const oldPrice=row.querySelector(':scope > strong');
        if(oldPrice){
          const holder=document.createElement('div');
          holder.innerHTML=priceStackHTML(pricing);
          oldPrice.replaceWith(holder.firstElementChild);
        }
        row.dataset.ppV17Priced='true';
      });
      const foot=drawer.querySelector('[data-pp-cart-foot]');
      if(foot){
        let summary=foot.querySelector('[data-pp-v17-cart-summary]');
        if(!summary){
          summary=document.createElement('div');
          summary.dataset.ppV17CartSummary='true';
          const oldTotal=foot.querySelector('.pp-cart-drawer-total');
          if(oldTotal){oldTotal.dataset.ppV17Hidden='true';oldTotal.insertAdjacentElement('beforebegin',summary);}else{foot.prepend(summary);}
        }
        summary.innerHTML=summaryHTML(context);
      }
    }catch(error){console.warn('PurePind cart pricing enhancement skipped',error);}finally{drawerBusy=false;}
  }

  async function enhanceCartPage(){
    const cartPage=document.querySelector('.pp-cart');
    if(!cartPage||cartPage.dataset.ppV17Enhanced==='true')return;
    const rows=[...cartPage.querySelectorAll('.pp-cart-lines article')];
    if(!rows.length)return;
    try{
      const context=await getCartContext();
      rows.forEach((row,index)=>{
        const item=context.cart.items[index];
        if(!item)return;
        const handle=handleFromItem(item);
        const pricing=linePricing(item,context.byHandle.get(handle),handle);
        const oldPrice=row.querySelector(':scope > b');
        if(oldPrice){
          const holder=document.createElement('div');holder.innerHTML=priceStackHTML(pricing);oldPrice.replaceWith(holder.firstElementChild);
        }
      });
      const total=cartPage.querySelector('.pp-cart-total');
      if(total)total.innerHTML=summaryHTML(context);
      cartPage.dataset.ppV17Enhanced='true';
    }catch(error){console.warn('PurePind cart-page pricing enhancement skipped',error);}
  }

  function relabelComboPricing(){
    const handle=handleFromPath();
    if(!COMBOS[handle])return;
    const row=document.querySelector('[data-pp-product-page] .pp-product-price-row');
    if(!row)return;
    const mrpLabel=row.querySelector('.pp-price-mrp-label');
    const offerLabel=row.querySelector('.pp-price-offer-label');
    if(mrpLabel)mrpLabel.textContent='Buy separately';
    if(offerLabel)offerLabel.textContent='Bundle price';
  }

  async function setupComboPdp(){
    const handle=handleFromPath();
    const config=COMBOS[handle];
    const page=document.querySelector('[data-pp-product-page]');
    if(!config||!page||page.dataset.ppComboV17==='true')return;
    page.dataset.ppComboV17='true';
    const [combo,...componentProducts]=await Promise.all([fetchProduct(handle),...config.components.map(fetchProduct)]);
    const components=componentProducts.map((product,index)=>{
      const variant=includedVariant(product);
      return {handle:config.components[index],product,variant,image:imageUrl(product?.featured_image)||imageUrl(product?.images?.[0])};
    }).filter(item=>item.product&&item.image);
    if(!components.length)return;

    relabelComboPricing();
    const description=page.querySelector('.pp-product-description');
    if(description&&!page.querySelector('.pp-combo-jump')){
      const jump=document.createElement('a');jump.className='pp-combo-jump';jump.href='#pp-combo-inside';jump.textContent='See exactly what’s inside this box ↓';description.insertAdjacentElement('afterend',jump);
    }

    const main=page.querySelector('.pp-product-gallery-main');
    const mainImage=main?.querySelector('[data-pp-main-image]');
    const mediaWrap=page.querySelector('.pp-product-media');
    if(main&&mainImage&&mediaWrap&&!mediaWrap.querySelector('.pp-combo-thumbnails')){
      const stage=document.createElement('div');
      stage.className='pp-combo-all-stage';
      stage.style.setProperty('--pp-combo-count',String(components.length));
      stage.innerHTML=components.map(item=>`<figure><img src="${item.image}" alt="${item.product.title}"><figcaption>${item.product.title}</figcaption></figure>`).join('');
      main.appendChild(stage);
      mainImage.hidden=true;

      const thumbs=document.createElement('div');
      thumbs.className='pp-product-thumbnails pp-combo-thumbnails';
      thumbs.setAttribute('aria-label','Bundle product gallery');
      const all=document.createElement('button');
      all.type='button';all.className='is-active pp-combo-all-thumb';all.setAttribute('aria-label','View all products in the bundle');
      all.innerHTML=`<span>${components.slice(0,4).map(item=>`<img src="${item.image}" alt="">`).join('')}</span><small>All</small>`;
      thumbs.appendChild(all);
      components.forEach((item,index)=>{
        const button=document.createElement('button');button.type='button';button.setAttribute('aria-label','View '+item.product.title);button.innerHTML=`<img src="${item.image}" alt="${item.product.title}"><small>${index+1}</small>`;
        button.addEventListener('click',()=>{
          thumbs.querySelectorAll('button').forEach(b=>b.classList.remove('is-active'));button.classList.add('is-active');stage.hidden=true;mainImage.hidden=false;mainImage.src=item.image;mainImage.alt=item.product.title+' included in '+(combo?.title||'this bundle');
        });
        thumbs.appendChild(button);
      });
      all.addEventListener('click',()=>{
        thumbs.querySelectorAll('button').forEach(b=>b.classList.remove('is-active'));all.classList.add('is-active');mainImage.hidden=true;stage.hidden=false;
      });
      main.insertAdjacentElement('afterend',thumbs);
    }

    if(!page.querySelector('#pp-combo-inside')){
      const bundlePrice=Number(combo?.variants?.[0]?.price)||0;
      const separateValue=components.reduce((sum,item)=>sum+(Number(item.variant?.price)||0),0);
      const saving=Math.max(0,separateValue-bundlePrice);
      const savingPct=percentOff(separateValue,bundlePrice);
      const section=document.createElement('section');
      section.id='pp-combo-inside';section.className='pp-combo-inside';
      section.innerHTML=`
        <div class="pp-combo-inside__head"><div><p class="pp-eyebrow">${config.kicker}</p><h2>${config.headline}</h2></div><p>${config.copy}</p></div>
        <div class="pp-combo-value-strip">
          <div><span>Buy separately</span><s>${money(separateValue)}</s></div>
          <div><span>Bundle price</span><strong>${money(bundlePrice)}</strong></div>
          <div><span>You save</span><strong>${money(saving)}</strong></div>
          <div><span>Bundle saving</span><strong>${savingPct}% OFF</strong></div>
        </div>
        <div class="pp-combo-component-grid">${components.map(item=>`<a href="/products/${item.handle}"><span class="pp-combo-component-media"><img src="${item.image}" alt="${item.product.title}"></span><small>Included · 900 g</small><strong>${item.product.title}</strong><span>${money(Number(item.variant?.price)||0)} individually</span><b>View full product →</b></a>`).join('')}</div>
        <p class="pp-combo-note">The bundle contains the listed 900 g products. Individual product pages carry the complete ingredient, nutrition, allergen and preparation information for each item.</p>`;
      const band=page.querySelector('.pp-benefit-band');
      if(band)band.insertAdjacentElement('afterend',section);else page.querySelector('.pp-product-hero')?.insertAdjacentElement('afterend',section);
    }
  }

  function init(){
    enhanceCartPage();
    setupComboPdp();
    setTimeout(relabelComboPricing,0);
    const lines=document.querySelector('[data-pp-cart-lines]');
    if(lines){
      const observer=new MutationObserver(()=>{
        const missing=[...lines.querySelectorAll('.pp-cart-drawer-line')].some(row=>row.dataset.ppV17Priced!=='true');
        if(missing)setTimeout(enhanceDrawer,0);
      });
      observer.observe(lines,{childList:true,subtree:false});
      enhanceDrawer();
    }
    document.addEventListener('click',(event)=>{
      if(event.target.closest('[data-pp-cart-open], [data-pp-qty-plus], [data-pp-qty-minus], [data-pp-cart-remove]'))setTimeout(enhanceDrawer,220);
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
